import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=56029a29&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56029a29')) {
      api.createRecord('56029a29', component.options)
    } else {
      api.reload('56029a29', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=56029a29&", function () {
      api.rerender('56029a29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sale/Index.vue"
export default component.exports